import { AfterViewInit, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';

export interface DropdownOption {
  label: string;
  value: any;
  selected?: boolean
}

@Component({
  selector: 'app-input-dropdown',
  templateUrl: './input-dropdown.component.html',
  styleUrls: ['./input-dropdown.component.scss']
})
export class InputDropdownComponent implements OnInit {

  active: boolean = false;
  values: string[] = [];
  label: string = '';

  @Input() multiple: boolean = false;
  @Input({ required: true }) placeholder!: string;
  @Input({ required: true }) control!: FormControl;
  @Input() options: DropdownOption[] = []
  @Input() loading: boolean = false;
  @Input() height: number = 25;
  @Input() width?: number;

  // determina se true, comp não fica em cima do resto da pagina como costuma
  @Input() positionRelative = false;

  @Output() emitter = new EventEmitter<any>();

  ngOnInit(): void {
    if (this.control.value !== '') {
      this.values = this.control.value.trim().split(',');
      this.values = this.values.map(value => value.trim())
      this.options.forEach((option: DropdownOption) => {
        if (this.values.includes(option.label)) {
          option.selected = true;
        }
      })
      this.setValue();
    }
  }

  toogleDropdown(): void {
    if (!this.control.disabled) {
      this.active = !this.active;
    }
  }

  selectOption(option: DropdownOption): void {
    if (!this.multiple) {
      this.active = false;
      this.values = [option.label]
    } else {
      option.selected = !option.selected;
      this.values.includes(option.label)
        ? this.values.splice(this.values.indexOf(option.label), 1)
        : this.values.push(option.label);

      this.values.sort();
    }

    this.setValue();
    this.emitter.emit(option.value)
  }

  setValue(): void {
    this.label = this.values.join(', ')
    this.control.setValue(this.label);
  }
}
